export default "__VITE_ASSET__g2yvqpDK__"